
import React from 'react';
import { FacilityOrderTemplateItemNewFlowActivatePatientModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateItemNewFlowActivatePatientModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateItemNewFlowActivatePatientModalStore(rootStore, componentProps), 'facilityOrderTemplateItemNewFlowActivatePatientModalStore')
@observer
class FacilityOrderTemplateItemNewFlowActivatePatientModal extends React.Component {
    render() {
        return <FacilityOrderTemplateItemNewFlowActivatePatientModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateItemNewFlowActivatePatientModal;
